import React, { useState, useRef, useEffect } from "react";
import { getStorage, deleteObject, ref, uploadBytesResumable, uploadBytes, getDownloadURL, UploadMetadata } from "firebase/storage";
import { storage } from "../../firebase";

interface UseUploadAudioReturn {
	progress: number;
	uploadError: string | null;
	downloadURL: string | null;
	loading: boolean;
	upload: (file: Blob, fileName: string, uid: string, onUploadComplete: (url: String, fileName: String) => void) => void;
}

interface UploadProfileImageProps {
	file: string | Blob;
	fileName: string;
	uid: string;
	downloadURL: string | null;
}

const UploadProfileImage = async (file: any, fileName: string, uid: string): Promise<UploadProfileImageProps> => {
	console.log("uid: " + uid);
	let downloadURL: string | undefined;
	//let uploadError: string | null = null;

	try {
		const storageRef = ref(storage, `profile/${uid}/${fileName}`);
		const metadata: UploadMetadata = {
			contentType: "image/png" // Adjust the content type as needed
		};
		const snapshot = await uploadBytes(storageRef, file, metadata);
		downloadURL = await getDownloadURL(snapshot.ref);
		console.log("downloadUrl: " + downloadURL);
		//setDownloadURL(downloadURL);
	} catch (err: any) {
		//uploadError = "An unexpected error occurred.";
		console.error("Error uploading profile image:", err);
		//setUploadError(err.message);
	}

	//console.log("downloadUrl: " + downloadURL);
	return { file, fileName, uid, downloadURL };
};

const useUploadAudio = (): UseUploadAudioReturn => {
	const [progress, setProgress] = useState(0);
	const [uploadError, setUploadError] = useState<string | null>(null);
	const [downloadURL, setDownloadURL] = useState<string | null>(null);
	const [loading, setLoading] = useState(Boolean);
	const lastProgressRef = useRef<number>(0); // Use useRef to track the last valid progress
	const unsubscribeRef = useRef<(() => void) | null>(null); //Ref to store unsubscribe function

	const upload = (file: Blob, fileName: string, uid: string, onUploadComplete: (url: string, fileName: string) => void) => {
		console.log("made it to upload");
		setLoading(true);
		// lastProgressRef.current = 0; // Reset at the start of each upload
		try {
			const storageRef = ref(storage, `catalog/${uid}/${fileName}`);
			const uploadTask = uploadBytesResumable(storageRef, file);

			unsubscribeRef.current = uploadTask.on(
				"state_changed",
				(snapshot) => {
					const progressPercent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

					if (progressPercent >= lastProgressRef.current) {
						setTimeout(() => {
							lastProgressRef.current = progressPercent;
							setProgress(progressPercent);
						}, 3000);
					}
				},
				(error) => {
					setLoading(false);
					setUploadError(error.message);
					if (unsubscribeRef.current) {
						unsubscribeRef.current();
						unsubscribeRef.current = null;
					}
				},
				() => {
					getDownloadURL(uploadTask.snapshot.ref).then((url) => {
						setDownloadURL(url);
						onUploadComplete(url, fileName);
						setLoading(false);
					});
					if (unsubscribeRef.current) {
						unsubscribeRef.current();
						unsubscribeRef.current = null;
					}
				}
			);
		} catch (err) {
			setLoading(false);
			setUploadError("An unexpected error occurred.");
			console.error("Error uploading audio:", err);
			// Cleanup if an error occurs during task creation
			if (unsubscribeRef.current) {
				unsubscribeRef.current();
				unsubscribeRef.current = null;
			}
		}
	};

	useEffect(() => {
		// Clean up the listener when the component unmounts or when the upload is complete.
		return () => {
			if (unsubscribeRef.current) {
				unsubscribeRef.current();
				unsubscribeRef.current = null;
			}
		};
	}, []);

	return { progress, uploadError, downloadURL, loading, upload };
};

const deleteAudio = (uid: string, fileName: string) => {
	const storageRef = ref(storage, `catalog/${uid}/${fileName}`);
	deleteObject(storageRef).catch((error) => {
		console.log("Error deleting object: " + error);
	});
};

export { useUploadAudio, UploadProfileImage, deleteAudio };
